module.exports = __webpack_public_path__ + "img/search_05.e9ebe832.png";